<template>
  <generic-modal :title="$t('credit card payment')" ref="generic_modal">
    <form>
      <div class="field">
        <label class="label">{{ $t("card number") }}</label>
        <div class="control">
          <input class="input" type="text" v-model="meta.card_number" />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("expiration date") }}</label>
        <div class="control">
          <input class="input" type="text" v-model="meta.expiration_date" />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("cvv") }}</label>
        <div class="control">
          <input class="input" type="text" v-model="meta.cvv" />
        </div>
      </div>
    </form>
    <p class="buttons is-pulled-right mt-2">
      <a class="button is-static is-size-5 has-text-info">
        {{ format_currency(total) }} <br />
        {{ $t("total") }}
      </a>
    </p>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        v-bind:class="{ 'is-loading': loading }"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  format_currency,
  put,
  // post,
  generate_error_message_text,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "VisanetPaymentModal",
  components: { GenericModal },
  props: {
    profile_uuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      meta: {},
      total: 0,
      error: "",
      loading: false,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.card_number || !v.meta.expiration_date || !v.meta.cvv;
    },
  },
  methods: {
    format_currency,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(total) {
      let v = this;
      v.set_initial_state();
      v.total = total;
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let payment_info = { ...v.meta };
      payment_info.profile_uuid = v.profile_uuid;
      payment_info.total = v.total;
      v.$root.loader(true);
      v.loading = true;
      put("/visanet_payment/transaction", payment_info)
        .then(() => {
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
          v.loading = false;
        });
    },
    set_initial_state() {
      let v = this;
      v.provider_uuid = undefined;
      v.meta = {
        card_number: "",
        expiration_date: "",
        cvv: "",
      };
      v.loading = false;
      v.total = 0;
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
